import { render } from "./EnjoinDetail.vue?vue&type=template&id=2e772fc4&scoped=true&ts=true"
import script from "./EnjoinDetail.ts?vue&type=script&lang=ts"
export * from "./EnjoinDetail.ts?vue&type=script&lang=ts"

import "./EnjoinDetail.scss?vue&type=style&index=0&id=2e772fc4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e772fc4"]])

export default __exports__